import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

import Button from 'core/ui/Button';

import { getColor, TrackUtil } from 'core/utils';
import Envelope from 'core/icons/Envelope';

const Icon = styled.div`
	font-size: 18px;
	margin-right: 12px;
	color: ${getColor("white")};
`;

const ContactSellerButton = ({
	className,
	label,
	notLoggedLabel,
	contactIcon,
	size,
	element,
	isLoggedIn,
	triggerLogin,
	openModal,
	fullWidth,
	themeType,
}) => {

	const handleTriggerLogin = () => {
		TrackUtil.trackEvent('login_prompt', {
			statjoy: [{
				step_name: 'contact_seller',
			}]
		});
		triggerLogin('contact_seller', 'contact-seller');
		return;
	};

	const handleClick = (e) => {
		e.preventDefault();
		if (!isLoggedIn) {
			handleTriggerLogin();
		}
		openModal(true);
	};

	const buttonText = isLoggedIn ? label : notLoggedLabel;

	if (element === "link") return (
		<a
			href="#"
			className={classNames(className)}
			onClick={handleClick}>
			{buttonText}
		</a>
	);

	return (
		<Button
			fullWidth={fullWidth}
			themeType={themeType}
			size={size}
			onClick={handleClick}
			className={classNames(className)}>
			{contactIcon &&
								<Icon>
									<Envelope fill={'currentColor'} />
								</Icon>
			}
			<span>{buttonText}</span>
		</Button>
	);
};

ContactSellerButton.propTypes = {
	className: PropTypes.string,
	label: PropTypes.string,
	notLoggedLabel: PropTypes.string,
	contactIcon: PropTypes.string,
	size: PropTypes.oneOf(['sm', 'md', 'lg']),
	element: PropTypes.oneOf(['link', 'button']),
	isLoggedIn: PropTypes.bool,
	triggerLogin: PropTypes.func.isRequired,
	openModal: PropTypes.func.isRequired,
	fullWidth: PropTypes.bool,
	themeType: PropTypes.string,
};

ContactSellerButton.defaultProps = {
	className: '',
	label: 'Contact Seller',
	notLoggedLabel: 'Sign in to contact the seller',
	size: 'lg',
	element: 'button',
	openModal: () => null,
	themeType: 'positive',
};

export default ContactSellerButton;
